
import React from "react";
import { Upload, Button, Typography } from "antd";
import { UploadOutlined, DownloadOutlined } from "@ant-design/icons";
import "./DocumentUploadCard.css";
import {
    FileOutlined,
    FilePdfOutlined,
    FileImageOutlined,
} from '@ant-design/icons';
const { Text } = Typography;

const PdfDocumentUploadCard = ({
  title,
  formats = "PDF",
  maxSize = "4000 KB",
  uploadProps = {},
  fileList = [],
  uploadedUrl = null,
  isDemoDownloadRequired = false,
  demoFileUrl
}) => {
  console.log("Uploaded URL:", demoFileUrl);
  return (
    <div className="custom-upload-card-wrapper">
      {/* Title and Metadata */}
      <div className="upload-card-info">
        <Text className="upload-card-title">{title}</Text>
        {!uploadedUrl && (
          <Text className="upload-card-meta">
            Format: {formats}
          </Text>
        )}
      </div>

      {
        isDemoDownloadRequired && (
          <Button
            type="link"
            className="pfs-template-link"
            icon={<DownloadOutlined />}
            onClick={() =>
              window.open(demoFileUrl, "_blank")
            }
          >
            Download PFS Template
          </Button>
        )
      }

      {/* Dashed Upload Button Area */}
      <Upload {...uploadProps} fileList={fileList} className="full-width-upload"
        iconRender={() => (
            <img src="/SVG.svg" alt="icon" />
        )}
      >
        {!uploadedUrl && (
          <Button 
            className="dashed-upload-area" 
            icon={<UploadOutlined className="upload-icon-style" />}
          >
            Upload File
          </Button>
        )}
      </Upload>
    </div>
  );
};

export default PdfDocumentUploadCard;